import { Router, RouteLocationNormalized } from 'vue-router'
import { useUserStore } from '@/store/modules/user'

const useLoading = (router: Router) => {
  router.afterEach((to: RouteLocationNormalized) => {
    if (to.meta.title) {
      const userStore = useUserStore()
      const staffPrefix = userStore.isStaff ? `[${userStore.userID}] ` : ''
      document.title = `${staffPrefix}${to.meta.title as string}`
    }
  })
}

export default useLoading
